import {Product as ProductInterface} from 'components/customer/Product/entity/Product';
import {PartialRoom} from 'shared/types/PartialRoom';
import {SelectionInterface} from 'components/customer/Product/helpers/entity/SelectionRules';
import {ShelfSetBack} from 'assets';
import {ShelfStyle} from 'components/customer/Preview3D/helpers/Utils';

/**
 * The setbacks the customer actually chose. Mirrors JobCabinets::buildShelves():
 * only an Advanced options shelf that isn't system drilled keeps its posted
 * setback — every other shelf is saved with the room default (or System 32's
 * fixed setback), so its form value is stale and not a selection.
 *
 * @param {ProductInterface} product Mapped product values about to be saved
 * @return {number[]} Customer-chosen setbacks
 */
const getChosenShelfSetBacks = (product: ProductInterface): number[] => {
    const advancedShelvesEnabled =
        product.cabinet_simple_shelves !== undefined &&
        product.cabinet_simple_shelves !== null &&
        !product.cabinet_simple_shelves;

    if (!advancedShelvesEnabled || !Array.isArray(product.shelf_offset)) {
        return [];
    }

    return product.shelf_offset.filter((offset, i) => {
        const style = Number(product.shelf_style?.[Number(i)]);

        return (
            style !== ShelfStyle.SYSTEM_32 && style !== ShelfStyle.CONTINUOUS
        );
    });
};

export const getShelfSelection = ({
    product,
    room,
    measurement,
}: {
    product: ProductInterface;
    room: PartialRoom;
    measurement: string;
}): SelectionInterface[] => {
    const rules = [];

    const changedShelf = getChosenShelfSetBacks(product).find(
        (item) => Number(item) !== Number(room.shelfSetBack)
    );
    if (typeof changedShelf !== 'undefined') {
        rules.push({
            key: 'shelf_set_back',
            name: 'Shelf Set Back',
            is_saved:
                room.customerOptions && room.customerOptions.isShelfSetBackSet,
            set_key: 'isShelfSetBackSet',
            room_data: `${room.shelfSetBack} ${measurement}`,
            product_data: `${changedShelf} ${measurement}`,
            value: changedShelf,
            image: String(ShelfSetBack),
            apply_to_room: true,
        });
    }

    return rules;
};
